// AUTO-GENERATED by scripts/generate-i18n-namespaces.ts. Do not edit.
// Run `pnpm gen` (or `pnpm gen:i18n`) to regenerate.

type ResourceLoader = () => Promise<{ default: Record<string, unknown> }>;

export const webappNamespaces = [
  "common",
  "component/reservation-form",
  "page/checkin",
  "page/invitation",
  "page/reservation",
  "page/reservation-status",
  "page/tentative-reservations",
] as const;

export const domainNamespaceList = [
  "accommodation-facility-type",
  "accommodation-fee-item",
  "accommodation-reservation",
  "country",
] as const;

export const webappResourceMap: Record<string, ResourceLoader> = {
  "ja/common": () => import("../../i18n/locales/ja/common.json"),
  "ja/component/reservation-form": () =>
    import("../../i18n/locales/ja/component/reservation-form.json"),
  "ja/page/checkin": () => import("../../i18n/locales/ja/page/checkin.json"),
  "ja/page/invitation": () =>
    import("../../i18n/locales/ja/page/invitation.json"),
  "ja/page/reservation": () =>
    import("../../i18n/locales/ja/page/reservation.json"),
  "ja/page/reservation-status": () =>
    import("../../i18n/locales/ja/page/reservation-status.json"),
  "ja/page/tentative-reservations": () =>
    import("../../i18n/locales/ja/page/tentative-reservations.json"),
  "en/common": () => import("../../i18n/locales/en/common.json"),
  "en/component/reservation-form": () =>
    import("../../i18n/locales/en/component/reservation-form.json"),
  "en/page/checkin": () => import("../../i18n/locales/en/page/checkin.json"),
  "en/page/invitation": () =>
    import("../../i18n/locales/en/page/invitation.json"),
  "en/page/reservation": () =>
    import("../../i18n/locales/en/page/reservation.json"),
  "en/page/reservation-status": () =>
    import("../../i18n/locales/en/page/reservation-status.json"),
  "en/page/tentative-reservations": () =>
    import("../../i18n/locales/en/page/tentative-reservations.json"),
  "zh-CN/common": () => import("../../i18n/locales/zh-CN/common.json"),
  "zh-CN/component/reservation-form": () =>
    import("../../i18n/locales/zh-CN/component/reservation-form.json"),
  "zh-CN/page/checkin": () =>
    import("../../i18n/locales/zh-CN/page/checkin.json"),
  "zh-CN/page/invitation": () =>
    import("../../i18n/locales/zh-CN/page/invitation.json"),
  "zh-CN/page/reservation": () =>
    import("../../i18n/locales/zh-CN/page/reservation.json"),
  "zh-CN/page/reservation-status": () =>
    import("../../i18n/locales/zh-CN/page/reservation-status.json"),
  "zh-CN/page/tentative-reservations": () =>
    import("../../i18n/locales/zh-CN/page/tentative-reservations.json"),
  "zh-TW/common": () => import("../../i18n/locales/zh-TW/common.json"),
  "zh-TW/component/reservation-form": () =>
    import("../../i18n/locales/zh-TW/component/reservation-form.json"),
  "zh-TW/page/checkin": () =>
    import("../../i18n/locales/zh-TW/page/checkin.json"),
  "zh-TW/page/invitation": () =>
    import("../../i18n/locales/zh-TW/page/invitation.json"),
  "zh-TW/page/reservation": () =>
    import("../../i18n/locales/zh-TW/page/reservation.json"),
  "zh-TW/page/reservation-status": () =>
    import("../../i18n/locales/zh-TW/page/reservation-status.json"),
  "zh-TW/page/tentative-reservations": () =>
    import("../../i18n/locales/zh-TW/page/tentative-reservations.json"),
};

export const domainResourceMap: Record<string, ResourceLoader> = {
  "ja/accommodation-facility-type": () =>
    import("@sa-nu/i18n/locales/ja/accommodation-facility-type.json"),
  "ja/accommodation-fee-item": () =>
    import("@sa-nu/i18n/locales/ja/accommodation-fee-item.json"),
  "ja/accommodation-reservation": () =>
    import("@sa-nu/i18n/locales/ja/accommodation-reservation.json"),
  "ja/country": () => import("@sa-nu/i18n/locales/ja/country.json"),
  "en/accommodation-facility-type": () =>
    import("@sa-nu/i18n/locales/en/accommodation-facility-type.json"),
  "en/accommodation-fee-item": () =>
    import("@sa-nu/i18n/locales/en/accommodation-fee-item.json"),
  "en/accommodation-reservation": () =>
    import("@sa-nu/i18n/locales/en/accommodation-reservation.json"),
  "en/country": () => import("@sa-nu/i18n/locales/en/country.json"),
  "zh-CN/accommodation-facility-type": () =>
    import("@sa-nu/i18n/locales/zh-CN/accommodation-facility-type.json"),
  "zh-CN/accommodation-fee-item": () =>
    import("@sa-nu/i18n/locales/zh-CN/accommodation-fee-item.json"),
  "zh-CN/accommodation-reservation": () =>
    import("@sa-nu/i18n/locales/zh-CN/accommodation-reservation.json"),
  "zh-CN/country": () => import("@sa-nu/i18n/locales/zh-CN/country.json"),
  "zh-TW/accommodation-facility-type": () =>
    import("@sa-nu/i18n/locales/zh-TW/accommodation-facility-type.json"),
  "zh-TW/accommodation-fee-item": () =>
    import("@sa-nu/i18n/locales/zh-TW/accommodation-fee-item.json"),
  "zh-TW/accommodation-reservation": () =>
    import("@sa-nu/i18n/locales/zh-TW/accommodation-reservation.json"),
  "zh-TW/country": () => import("@sa-nu/i18n/locales/zh-TW/country.json"),
};
